import { Component, Renderer, ViewChild  } from '@angular/core';
import { NavController, NavParams, Content } from 'ionic-angular';
import { SafeResourceUrl, DomSanitizer} from '@angular/platform-browser';
//Pages
import {PalestrantePerfilPage} from '../palestrante-perfil/palestrante-perfil';
//Providers
import { ConfigProvider } from '../../providers/config-provider';
import { UtilProvider } from '../../providers/util-provider';
import { CongressoProvider } from '../../providers/congresso-provider';
import { LecturerProvider } from '../../providers/lecturer-provider';
import { AuthProvider } from '../../providers/auth-provider';
import { StorageProvider } from '../../providers/storage-provider';
//Components
import { CustomAlert } from '../../components/custom-alert.component';
import { RefreshInfoComponent } from '../../components/refresh-info/refresh-info.component';
//Models
import { Url } from '../../models/url.model';
import { Lecturer } from '../../models/lecturer.model';
import { DayProgram } from '../../models/day-program.model';
import { Program } from '../../models/program.model';
import { User } from '../../models/user.model';
import { Congresso } from '../../models/congresso.model';

@Component({
    selector: 'page-palestrantes',
    templateUrl: 'palestrantes.html'
})
export class PalestrantesPage {

    @ViewChild(Content) content: Content;

    public user: User;
    public congresso: Congresso;
    public palestrantes: Array<Lecturer>;
    public palestrantesFiltrados: Array<Lecturer>;
    public favoritos: any[];
    public loaded: boolean;
    public currentPageClass = this;
    public imgDefault: string;
    public secondaryLight: string;
    private isCurrent: boolean;
    private count: number;
    private onlyFavorites: boolean;
    private LOADCOUNT: number = 20;
    private isSearchSelected = true;
    private searchTerm: string = "";
    private program: Program;
    private searchTermPalestrante: string = "";
    private hiddenList = true;
    private lastRefreshDate: string;
    private dateRef: string;
    private noScrolling: boolean = true;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        public palestrantesProvider: LecturerProvider,
        public utilProvider: UtilProvider,
        public auth: AuthProvider,
        public alert: CustomAlert,
        public configProvider: ConfigProvider,
        private renderer: Renderer,
        private storageProvider: StorageProvider,
        public sanitizer: DomSanitizer) {
        this.program = new Program();
        this.program.Days = new Array<DayProgram>();
        this.palestrantes = new Array<Lecturer>();
        this.palestrantesFiltrados = new Array<Lecturer>();
        this.imgDefault = this.configProvider.IMAGE_DEFAULT;
        this.user = JSON.parse(localStorage.getItem("user")) as User;
        this.congresso = this.congresso = JSON.parse(localStorage.getItem('congresso')) as Congresso;
        this.secondaryLight = this.utilProvider.lightenDarkenColor(this.congresso.CorSecundaria, 50.9);
        this.loaded = false;
        this.onlyFavorites = false;
        this.isCurrent = this.congresso.Ano == configProvider.ANO_ATUAL || this.congresso.Liberado;
    }

    ionViewWillEnter() {

        this.hiddenList = true;
        if (this.count > this.LOADCOUNT)
            this.loaded = false;
    }

    ionViewDidEnter() {
        this.loaded = false;
        this.lastRefreshDate = this.storageProvider.get('lastRefreshDate');
        this.dateRef = this.utilProvider.formaRefreshDate(this.lastRefreshDate)

        var views = this.navCtrl.getViews();

        if (views.length == 1) {
            this.palestrantesFiltrados = new Array<Lecturer>();
            this.init();
        }
        else this.loaded = true;

        this.favoritos = localStorage.getItem("palestrantesFavoritos") ? JSON.parse(localStorage.getItem("palestrantesFavoritos")) : new Array<any>();
        let scroll = localStorage.getItem('PalestrantesScroll') ? +localStorage.getItem('PalestrantesScroll') : 0;
        this.content.scrollTo(0, scroll).then(x => {
            this.hiddenList = false;
        });
    }

    init() {
        this.get();
        this.utilProvider.searchInFocus = false;
        this.utilProvider.searchTerm = "";

        if (this.palestrantesFiltrados)
            this.searchPalestrantesByTerm(this.searchTermPalestrante, this.onlyFavorites);

        this.count = this.LOADCOUNT;
    }

    get() {
        let self = this;
       // if (!self.lastRefreshDate || self.utilProvider.checkTimeToRefresh(self.lastRefreshDate)) {
            if (self.utilProvider.isConnected(true)) {
                let user = self.user ? self.user : new User();
                setTimeout(() => {
                    this.palestrantesProvider.getPalestrantes(self.congresso.Ano, user.Guid)
                        .then(res => {
                            self.palestrantes = res;

                            self.palestrantes.forEach(x => {
                                x.Image = this.sanitizer.bypassSecurityTrustStyle('url(' + x.PathPhoto + ')');
                            });

                            self.palestrantesFiltrados = self.palestrantes.slice(0, this.count);

                            self.loaded = true;
                            self.setLocalStorage();
                        })
                        .catch(response => {
                            let err = response;
                            if (err) {

                              self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
                            }
                        });
                }, 0);
            }
            else {
                self.getFromStorage();
            }
        // }
        // else {
        //     self.getFromStorage();
        // }
    }

    getFromStorage() {
        let self = this;
        
        if (localStorage.getItem('palestrantes')) {
            self.palestrantes = JSON.parse(localStorage.getItem('palestrantes')).sort(function (a, b) {
                return a.Nome.localeCompare(b.Nome);
            });
            self.palestrantes.forEach(x => {
                x.Image = this.sanitizer.bypassSecurityTrustStyle('url(' + x.PathPhoto + ')');
            });
            self.palestrantesFiltrados = self.palestrantes.slice(0, this.count);
            self.loaded = true;
        }
        else{
            self.program.Days = self.storageProvider.get('atividadesDia') as Array<DayProgram>;
            self.palestrantes = new Array<Lecturer>();
            self.program.Days.forEach((x) => {
                Array.prototype.push.apply(self.palestrantes, x.Palestrantes);
            });

            localStorage.setItem('palestrantes', self.palestrantes ? JSON.stringify(self.palestrantes.filter((thing, index, self) => self.findIndex((t) => { return t.Nome === thing.Nome; }) === index).sort()) : '');

            self.palestrantes = JSON.parse(localStorage.getItem('palestrantes')).sort(function (a, b) {
                return a.Nome.localeCompare(b.Nome);
            });
            self.palestrantes.forEach(x => {
                x.Image = this.sanitizer.bypassSecurityTrustStyle('url(' + x.PathPhoto + ')');
            });
            self.palestrantesFiltrados = self.palestrantes.slice(0, this.count);
            self.loaded = true;
        }
    }

    setLocalStorage() {
        let palestrantes = this.palestrantes;
        localStorage.setItem('palestrantes', palestrantes ? JSON.stringify(palestrantes) : '');

    }

    getOnlyFavorites() {
        this.onlyFavorites = !this.onlyFavorites;

        this.searchPalestrantesByTerm(this.searchTermPalestrante, this.onlyFavorites);
    }

    toggleFavorite(palestrante) {
        if (this.utilProvider.isConnected(true) && this.auth.isAuthorized()) {

            if (this.isFavorite(palestrante))
                this.removeFavorite(palestrante);
            else
                this.addFavorite(palestrante);

            palestrante.IsFavorito = !palestrante.IsFavorito;
        }
    }

    changeFavorite(palestrante, event) {
        if (this.isCurrent && this.utilProvider.isConnected(true) && this.auth.isAuthorized()) {

            if (this.isFavorite(palestrante))
                this.removeFavorite(palestrante);
            else
                this.addFavorite(palestrante);

            palestrante.IsFavorito = !palestrante.IsFavorito;
        }
        if (event)
            event.stopPropagation();
    }

    isFavorite(p: Lecturer) {
        return p.IsFavorito || (localStorage.getItem("palestrantesFavoritos") && JSON.parse(localStorage.getItem("palestrantesFavoritos")).some(x => x.PalestranteSgunId == p.SgunId));
    }

    openProfilePage(p: Lecturer) {
        localStorage.setItem('PalestrantesScroll', this.content.scrollTop.toString())
        this.navCtrl.push(PalestrantePerfilPage, {
            palestrante: p,
        });

    }

    doInfinite(infiniteScroll) {
        var self = this;

        setTimeout(() => {
            if (self.count <= self.palestrantesFiltrados.length) {
                if (self.searchTermPalestrante || self.onlyFavorites)
                    Array.prototype.push.apply(self.palestrantesFiltrados, self.palestrantesFiltrados.slice(self.count, self.count + self.LOADCOUNT));
                else
                    Array.prototype.push.apply(self.palestrantesFiltrados, self.palestrantes.slice(self.count, self.count + self.LOADCOUNT));
            }

            self.count = this.palestrantesFiltrados.length;

            infiniteScroll.complete();
        }, 0);

    }

    searchPalestrantesByTerm(ev: any, onlyFavorites) {
        this.palestrantesFiltrados = this.palestrantes;

        let val = ev;
        if (ev.target)
            val = ev.target.value;

        if (this.onlyFavorites) {
            this.palestrantesFiltrados = new Array<Lecturer>();
            this.palestrantesFiltrados = this.palestrantes.filter(p => this.isFavorite(p));
        }

        if (val && val.trim() && this.palestrantesFiltrados.length != 0) {

            this.palestrantesFiltrados = this.palestrantesFiltrados.filter((p) => {
                return (this.utilProvider.prepareSearch(p.Nome).includes(this.utilProvider.prepareSearch(val)));
            });
        }



        if (!val && !this.onlyFavorites)
            this.palestrantesFiltrados = this.palestrantes.slice(0, this.LOADCOUNT);

        this.count = this.palestrantesFiltrados.length;

        if (ev.target)
            this.renderer.invokeElementMethod(ev.target, 'blur');
    }

    addFavorite(p: Lecturer) {
        let self = this;
        if (self.utilProvider.isConnected(true)) {
            self.utilProvider.loadingShow();
            self.palestrantesProvider.adicionarPalestranteFavorito(this.user.Guid, p.SgunId.toString())
                .then(res => {
                    self.utilProvider.loadingHide();
                    self.favoritos.push({ Id: p.Id, GuidSgun: '', PalestranteSgunId: p.SgunId });
                    localStorage.setItem('palestrantesFavoritos', JSON.stringify(self.favoritos));
                    p.IsFavorito = true;
                    self.alert.showAlert('Sucesso', 'Palestrante adicionado!');
                })
                .catch(response => {
                    let err = response;
                    if (err) {
                        self.utilProvider.loadingHide();

                        self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
                    }
                });
        }
    }

    removeFavorite(p: Lecturer) {
        let self = this;
        if (self.utilProvider.isConnected(true)) {
            self.utilProvider.loadingShow();
            self.palestrantesProvider.removerPalestranteFavorito(this.user.Guid, p.SgunId)
                .then(res => {
                    self.favoritos = self.favoritos.filter(x => x.PalestranteSgunId != p.SgunId);
                    localStorage.setItem('palestrantesFavoritos', JSON.stringify(self.favoritos));
                    p.IsFavorito = false;
                    self.utilProvider.loadingHide();
                    self.alert.showAlert('Sucesso', 'Palestrante removido.');
                })
                .catch(response => {
                    let err = response;
                    if (err) {
                        self.utilProvider.loadingHide();

                        self.alert.showAlert('Falha de conexão', 'Não foi possível obter os dados do servidor');
                    }
                });
        }
    }

    hasResult() {
        return this.palestrantesFiltrados && this.palestrantesFiltrados.length != 0;
    }

}



// WEBPACK FOOTER //
// ./src/pages/palestrantes/palestrantes.ts